module.exports = __webpack_public_path__ + "img/module-img_loading.png?fb4febd1";